// @file Composable that provides methods for sorting sections
import type { Section } from '@@/types'

export const useSectionSorterHelper = (): {
  getNewIndexBetween: typeof getNewIndexBetween
} => {
  const getSortIndex = (timestamp?: Date): number => {
    if (timestamp == null) {
      timestamp = new Date()
    }
    return new Date(timestamp.toISOString()).getTime() / 1000
  }
  const getTopSortIndex = (): number => {
    return -getSortIndex()
  }
  const getBottomSortIndex = (): number => {
    return getSortIndex()
  }

  const getNewIndexBetween = (
    previousSection?: Section | null,
    nextSection?: Section | null,
  ): { sortIndex?: number; gapSize?: number } => {
    // Do nothing if either group is null
    if (previousSection == null || nextSection == null) {
      return {}
    }
    let prevIndex: number | null = previousSection?.sort_index ?? null
    let nextIndex: number | null = nextSection?.sort_index ?? null

    if (prevIndex == null) {
      // moved to top
      prevIndex = getTopSortIndex()
    }

    if (nextIndex == null) {
      // moved to bottom
      nextIndex = getBottomSortIndex()
    }

    // New sort index is the average of the two adjacent sections' sort indices
    const sortIndex = Math.round((prevIndex + nextIndex) / 2)
    // Might be NaN, which translates to a nil in controller.
    const gapSize = Math.abs(nextIndex - prevIndex)
    return { sortIndex, gapSize }
  }

  return { getNewIndexBetween }
}
